// -- React Libraries
import React from 'react';

// -- Components
import GridAppName from "../GridAppName/index";
import GridDescription from "../GridDescription/index";
import GridGraphics from "../GridGraphics/index";
import GridRating from "../GridRating/index";

// -- Styles
import StyleWrapper from "./Wrapper";

class DropdownList extends React.Component {
    constructor() {
        super();
        this.state = {
            isSelecting: false,
            selectedIndex: 0
        };
    }

    onSelect(option) {
        this.setState({isSelecting: false,});
        for (var i = 0; i < this.props.options.length; i++)
        {
            if (this.props.options[i].key == option.key)
            {
                this.setState({selectedIndex: i});
                break;
            }
        }
        this.props.onClick(option);
    }

    render() {
        {
            var $this = this;
            var optionComponents = this.props.options.map(function(option) {
                return (
                    <div className="options" key={option.key} onClick={ ()=> { $this.onSelect(option); } }>
                        {option.text}
                    </div>
                );
            });
        }
        return (
            <div
                className="section-selector-wrapper"
                onClick={ () => { this.setState({isSelecting: !this.state.isSelecting}); } }
            >
                <div className={`section-selector ${ this.state.isSelecting ? "selecting" : "" }`}>
                    <div className="section-selected">{this.props.options[this.state.selectedIndex].text}</div>
                    <div className="section-options">
                        {optionComponents}
                    </div>
                </div>
            </div>
        );
    }
}

export default class ScoreSummarySelects extends React.Component {
    constructor(props) {
        super(props);

        this.availableOptions = [
            {key: "app-name", text: "应用名称"},
            {key: "app-description", text: "描述"},
            {key: "app-graphics", text: "图像"},
            {key: "app-ratings", text: "评分及评论"}
        ];

        this.appNameAnalyze = props.analyzes.appName;
        this.appDescriptionAnalyze = props.analyzes.appDescription;
        this.appGraphicsAnalyze = props.analyzes.appGraphics;
        this.appRatingsAndReviewsAnalyze = props.analyzes.appRatingsAndReviews;

        this.state = { className: this.availableOptions[0].key };
    }

    handleDropDownChange(option) {
        this.setState({className: option.key});
    }

    componentDidMount() {
        setTimeout(function(){
            this.setState({opacity: 1});
        }.bind(this), 1);
    }

    render() {
        console.log(' data : ' + this.props.data);
        return (
            <StyleWrapper style={{opacity: this.state.opacity || 0}} className={this.state.className}>
                <DropdownList
                    options={this.availableOptions}
                    onClick={ (option) => { this.handleDropDownChange(option); } }
                />

                {
                    this.state.className == "app-description" && (
                        <GridDescription
                            // appDescription={this.props.app.description}
                            // isLengthOK={true}
                            // isSpellCheckOK={true}
                            // lengthLength={this.props.app.description.length}
                            // data={this.props.data}
                            data={this.appDescriptionAnalyze}
                        />
                    ) || (
                        this.state.className == "app-graphics" && (
                            <GridGraphics
                                // screenshotUrls={this.props.app.screenshotUrls}
                                // isQuantityOK={true}
                                // isShapeOK={false}
                                // isPreviewVideoOK={false}
                                // data={this.props.data}
                                data={this.appGraphicsAnalyze}
                            />
                        )
                    ) || (
                        this.state.className == "app-name" && (
                            <GridAppName
                                // appName={this.props.app.trackName}
                                // isFormatOK={true}
                                // isBrandingOK={true}
                                // isLengthOK={true}
                                // brandingLength={15}
                                // lengthLength={30}
                                // data={this.props.data}
                                data={this.appNameAnalyze}
                            />
                        )
                    ) || (
                        <GridRating
                            data={this.appRatingsAndReviewsAnalyze}
                        />
                    )
                }
            </StyleWrapper>
        );
    }
};


// WEBPACK FOOTER //
// ./src/containers/AsoAnalytic/ScoreSummary/Selects/index.js